import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useDiscoveryStore } from '@/store/useDiscoveryStore.ts';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

export const handleContactDeleted = async (ctxData: WebSocketMessage) => {
  if (ctxData.contact_deleted_event?.contact_hid) {
    const { removeCandidate } = useDiscoveryStore.getState();

    try {
      await removeCandidate(ctxData.contact_deleted_event?.contact_hid);
    } catch (e) {
      catchErrors(e);
    }
  }
};
